import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  const goodFit = ['You recently graduated or are about to graduate', 'You are applying but not getting traction', 'You are unsure what kind of work fits you', 'You feel behind or overwhelmed', 'You need help talking about your strengths', 'You want support, structure, and accountability', 'You are a parent looking for someone to help your grad get started'];
  const notFit = ['You only want someone to rewrite your resume', 'You are not ready to participate actively', 'You want a guaranteed job placement', 'You are looking for a large group program'];
  return <section className="py-20 md:py-24 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-187">
      <div className="text-center mb-16" data-id="element-188">
        <h2 className="text-4xl md:text-5xl font-serif" data-id="element-189">Who this is for</h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-190">
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-sage/30" data-id="element-191">
          <div className="flex items-center gap-3 mb-8" data-id="element-192">
            <div className="w-10 h-10 rounded-full bg-sage/20 flex items-center justify-center text-teal" data-id="element-193">
              <Check className="w-6 h-6" data-id="element-194" />
            </div>
            <h3 className="text-2xl font-serif" data-id="element-195">A good fit if:</h3>
          </div>
          <ul className="space-y-4" data-id="element-196">
            {goodFit.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink/80" data-id="element-197">
                <div className="w-1.5 h-1.5 rounded-full bg-teal mt-2.5 shrink-0" data-id="element-198"></div>
                <span data-id="element-199">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-mist/50 p-8 md:p-10 rounded-2xl border border-ink/5" data-id="element-200">
          <div className="flex items-center gap-3 mb-8" data-id="element-201">
            <div className="w-10 h-10 rounded-full bg-ink/5 flex items-center justify-center text-ink/60" data-id="element-202">
              <X className="w-6 h-6" data-id="element-203" />
            </div>
            <h3 className="text-2xl font-serif text-ink/60" data-id="element-204">Not a fit if:</h3>
          </div>
          <ul className="space-y-4" data-id="element-205">
            {notFit.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink/60" data-id="element-206">
                <div className="w-1.5 h-1.5 rounded-full bg-ink/20 mt-2.5 shrink-0" data-id="element-207"></div>
                <span data-id="element-208">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}